import { echo } from './echo'
import { axios } from './axios'

export default {
  echo,
  axios
}



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/vendor/index.js